import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedGallery from './components/FeaturedGallery';
import LatestUpdates from './components/LatestUpdates';
import FAQSection from './components/FAQSection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <FeaturedGallery />
        <LatestUpdates />
        <FAQSection />
      </main>
      <Footer />
      <ScrollToTop />
    </>
  );
}